<template>
  <!-- 注册 -->
  <el-dialog ref="dialog" :visible.sync="centerDialogVisible" :lock-scroll="false" width="30%" center :show-close="false">
    <div class="content">
      <div class="register">
        <div>注册</div>
        <div @click="centerDialogVisible = false" class="point">×</div>
      </div>
      <!-- <div style="color: #a9aeb8; line-height: 2; margin-bottom: 8px">
        国家知识产权国际运营平台
      </div> -->
      <!-- 手机邮箱注册切换 -->
      <div class="switch">
        <div class="regis">
          <el-tabs v-model="editableTabsValue" @tab-click="changeTab">
            <!-- 手机注册 -->
            <el-tab-pane label="手机注册">
              <el-form :model="dynamicValidateFormmobile" ref="dynamicValidateFormmobile" class="demo-dynamic">
                <!-- 手机号 -->
                <div>
                  <div class="email">手机号</div>
                  <el-form-item prop="mobile" :rules="rules.mobile">
                    <el-input type="tel" maxlength="11" placeholder="请输入手机号" v-model="dynamicValidateFormmobile.mobile">
                    </el-input>
                  </el-form-item>
                </div>
                <!-- 图形验证码 -->
                <div>
                  <div class="email">图形验证码</div>
                  <el-form-item prop="captcha">
                    <div style="display: flex;">
                      <el-input type="tel" maxlength="11" placeholder="请输入验证码"
                        v-model="dynamicValidateFormmobile.captcha">
                      </el-input>
                      <img :src="baseUrl + '/security/captcha'" alt="captcha" style="margin-left: 8px;cursor: pointer;"
                        @click="getCaptcha()" ref="captcha1">
                    </div>
                  </el-form-item>
                </div>
                <!-- 验证码 -->
                <div>
                  <div class="email">验证码</div>
                  <div>
                    <el-form-item prop="mobilein" :rules="rules.mobilein">
                      <el-input placeholder="输入4位验证码" maxlength="4" v-model="dynamicValidateFormmobile.mobilein">
                        <template slot="append">
                          <span style="margin-right: 14px; color: #c9cdd4">|</span>
                          <el-button @click="sendOutCode('countdown1')" type="primary" :disabled="judge || !dynamicValidateFormmobile.mobile
                            ">{{ countdown1 }}</el-button>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>

                <!-- 密码 -->
                <div>
                  <div class="email">密码</div>
                  <el-form-item prop="mobilepass" :rules="rules.mobilepass">
                    <el-input placeholder="请输入密码" type="password" id="pass" name="password" minlength="6" required
                      v-model="dynamicValidateFormmobile.mobilepass" autocomplete="off">
                    </el-input>
                  </el-form-item>
                </div>
                <!-- 阅读 -->
                <div class="check">
                  <el-checkbox v-model="radio">
                    我已阅读并同意
                    <a style="color: #165dff" href="javascript:;" @click="toXieyi">《用户协议》</a>
                  </el-checkbox>
                </div>
              </el-form>
              <!-- 注册  -->
              <el-button style="width: 100%" type="primary" :disabled="disBtn"
                @click="submitForm('dynamicValidateFormmobile')">
                注册</el-button>
              <div class="go">
                已有账号？<span style="color: #165dff" class="point" @click="loginChange">去登录</span>
              </div>
            </el-tab-pane>

            <!-- 邮箱注册 -->
            <el-tab-pane label="邮箱注册">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic">
                <!-- 邮箱 -->
                <div>
                  <div class="email">邮箱</div>
                  <el-form-item prop="email" :rules="rules.email">
                    <el-input placeholder="请输入邮箱" v-model="dynamicValidateForm.email"></el-input>
                  </el-form-item>
                </div>
                <!-- 图形验证码 -->
                <div>
                  <div class="email">图形验证码</div>
                  <el-form-item prop="captcha">
                    <div style="display: flex;">
                      <el-input type="tel" maxlength="11" placeholder="请输入验证码" v-model="dynamicValidateForm.captcha">
                      </el-input>
                      <img :src="baseUrl + '/security/captcha'" alt="captcha" style="margin-left: 8px;cursor: pointer;"
                        @click="getCaptcha()" ref="captcha2">
                    </div>
                  </el-form-item>
                </div>
                <!-- 验证码 -->
                <div>
                  <div class="email">验证码</div>
                  <div>
                    <el-form-item prop="input2" :rules="rules.mobilein">
                      <el-input placeholder="输入4位验证码" :maxlength="4" v-model="dynamicValidateForm.input2">
                        <template slot="append">
                          <span style="margin-right: 14px; color: #c9cdd4">|</span>
                          <el-button @click="sendOutCode('countdown')" type="primary"
                            :disabled="judge || !dynamicValidateForm.email">{{ countdown }}</el-button>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <!-- 密码 -->
                <div>
                  <div class="email">密码</div>
                  <el-form-item prop="pass" :rules="rules.pass">
                    <el-input placeholder="请输入密码" type="password" id="pass" name="password" minlength="6" required
                      v-model="dynamicValidateForm.pass" autocomplete="off">
                    </el-input>
                  </el-form-item>
                </div>

                <!-- 阅读 -->
                <div class="check">
                  <el-checkbox v-model="checked">
                    我已阅读并同意
                    <a style="color: #165dff" href="javascript:;" @click="toXieyi">《用户协议》</a>
                  </el-checkbox>
                </div>
              </el-form>
              <el-button style="width: 100%" type="primary" :disabled="disBtn" @click="submitForm('dynamicValidateForm')">
                注册
              </el-button>
              <div class="go">
                已有账号？<span style="color: #165dff" @click="loginChange" class="point">去登录</span>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div v-show="flag">
        <div class="gray"></div>
        <div class="verify">
          <dragVerifyImg ref="dragVerify" class="slide-box" :imgsrc="imgsrc" :isPassing.sync="isPassing"
            :showRefresh="true" text="请按住滑块拖动" successText="验证通过" handlerIcon="el-icon-d-arrow-right"
            successIcon="el-icon-circle-check" @passcallback="onSuccess">
          </dragVerifyImg>

          <div class="verify_img">
            <img src="../assets/quxiao.png" @click="flag = false" />
            <img src="../assets/shuaxin.png" @click="reset" />
          </div>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import { postRequest } from "../api/api";
import dragVerifyImg from "vue-drag-verify-img";
import { passwordVerification } from "../api/util";
import { baseUrl } from "../api/constant";
import {
  Dialog,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Button,
  Input,
  Checkbox,
} from "element-ui";
import Vue from "vue";
import router from "../router";

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);

let timer = "";
export default {
  components: {
    dragVerifyImg,
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (value.length === 0) {
        callback(new Error("请输入手机号"));
      } else if (value.length !== 11 || !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateMobilein = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入验证码"));
      } else if (value.length !== 4) {
        callback(new Error("验证码错误"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("请输入至少8位数密码"));
      } else if (!passwordVerification(value)) {
        callback(new Error("请输入至少大小字母数字符合包含2种"));
      } else {
        callback();
      }
    };
    const validatEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value.length === 0) {
        callback(new Error("请输入邮箱"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    return {
      baseUrl,
      flag: false,
      isPassing: false,
      centerDialogVisible: false,
      editableTabsValue: "",
      rules: {
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        mobilein: [
          {
            required: true,
            validator: validateMobilein,
            trigger: "blur",
          },
        ],
        mobilepass: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: validatEmail,
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur",
          },
        ],
      },
      visible: true,
      checkLogin: false,
      checkPhone: false,
      checked: false, //单选按钮
      radio: false,
      judge: false, //禁用按钮
      countdown1: "发送验证码",
      countdown: "发送验证码", //验证码倒计时
      dynamicValidateForm: {
        email: "", //邮箱
        pass: "", //请输入密码
        input2: "", //邮箱验证码
        captcha: ""
      },
      dynamicValidateFormmobile: {
        mobile: "", //手机号
        mobilepass: "", //请输入密码
        mobilein: "", //手机验证码
        captcha: ""
      },
      // 滑块用图片
      imgsrc:
        "http://celiang.oss-cn-hangzhou.aliyuncs.com/measurement/2022-04/26/y3zT5phpCPlkxi1650939813220426.jpg",
    };
  },
  computed: {
    disBtn() {
      if (this.editableTabsValue == "1") {
        return !(
          this.dynamicValidateForm.input2 &&
          this.dynamicValidateForm.email &&
          this.checked &&
          this.dynamicValidateForm.pass
        );
      } else if (this.editableTabsValue == "0") {
        return !(
          this.dynamicValidateFormmobile.mobilein &&
          this.radio &&
          this.dynamicValidateFormmobile.mobilepass &&
          this.dynamicValidateFormmobile.mobile
        );
      }
    },
  },
  methods: {
    // 更新图形验证码
    getCaptcha() {
      this.$refs.captcha1.src = baseUrl + '/security/captcha'
      this.$refs.captcha2.src = baseUrl + '/security/captcha'
    },
    // 跳转用户协议
    toXieyi() {
      let url = window.location.href  //获取url地址
      let ind = url.indexOf('#')
      if (ind == -1) return

      let urlBast = url.slice(0, ind)
      this.centerDialogVisible = false //关闭注册弹框
      window.location.href = `${urlBast}#/useragreement`  //跳转用户协议页面
    },
    // 拼图成功
    onSuccess() {
      // console.log("验证成功");
      // return;

      this.flag = false;
      this.reset();
      this.$message.success("注册中,请稍等");

      this.regesterFunc();
    },
    // 拼图刷新
    reset() {
      this.isPassing = false;
      this.$refs.dragVerify.reset();
    },
    changeTab() {
      this.getCaptcha()
      // console.warn('fjknjds ', this.checked);
      // clearInterval(timer);
      // if (this.editableTabsValue == '') {
      //     this.countdown = '发送验证码';
      // } else {
      //     this.countdown1 = '发送验证码';
      // }
    },
    open() {
      this.centerDialogVisible = true;
    },
    // 切换登录
    loginChange() {
      this.centerDialogVisible = false;
      this.$login({
        login: (data) => {
          if (data) {
            // 登录回调函数
            this.$store.commit("setUser", data);
          }
        },
      });
    },
    // 发送验证码{
    sendOutCode(countdown) {
      if (this[countdown].indexOf("倒计时") >= 0) return;
      this.sendOut();
      let time = 59;
      this[countdown] = `倒计时（${time}）`;
      timer = setInterval(() => {
        time--;
        this[countdown] = `倒计时（${time}）`;
        if (time < 1) {
          clearInterval(timer);
          this[countdown] = `重新发送`;
        }
      }, 1000);
    },
    // 发送验证码请求
    sendOut() {
      postRequest({
        url: `/api/v1/user/sendsms?type=register&mobile=${this.dynamicValidateFormmobile.mobile}`,
      }).then((res) => {
        if (res.data) {
          this.$message.success("验证码已发送，请注意查收");
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    submitForm(formName) {
      // console.warn(formName,'formName是还说呢么')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.flag = true;
          setTimeout(() => {
            this.reset();
          }, 100);
          this.formName = formName;
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs[this.formName].resetFields();
    },
    // 注册
    regesterFunc() {
      // 注册
      let data = {};
      if (this.editableTabsValue == "1") {
        data = {
          code: this.dynamicValidateForm.input2,
          email: this.dynamicValidateForm.email,
          password: this.dynamicValidateForm.pass,
          captcha: this.dynamicValidateForm.captcha
        };
      } else if (this.editableTabsValue == "0") {
        data = {
          code: this.dynamicValidateFormmobile.mobilein,
          //   email: "",
          password: this.dynamicValidateFormmobile.mobilepass,
          phone: this.dynamicValidateFormmobile.mobile,
          captcha: this.dynamicValidateFormmobile.captcha
        };
      }
      postRequest({ url: "/security/register", data })
        .then((res) => {
          console.warn(res.errmsg, "报什么");
          if (res.errcode == 200) {
            this.$emit("handleShow");
            this.centerDialogVisible = false;
            this.$message.success("注册成功");
            this.resetForm();
          } else {
            this.$message.error(res.errmsg);
          }
        })
        .catch(() => {
          this.flag = false;
          this.$message.error(res.errmsg);
        });
    },
  },
  created() {
  },
};
</script>
<style lang="scss" scoped>
.gray {
  background: #000;
  opacity: 0.5;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 90;
}

.verify {
  position: absolute;
  top: 33%;
  z-index: 91;
  background: #fff;
  padding: 9px 9px 0;
  box-sizing: border-box;

  .slide-box {
    // z-index: 92;
  }

  ::v-deep .slide-verify-refresh-icon {
    display: none;
  }

  ::v-deep .slide-verify-slider {
    margin-top: 15px;
  }

  .verify_img {
    background: #fff;
    border-top: 1px solid #e5e6eb;
    display: flex;
    margin-top: 15px;
    padding: 13px 15px;
    box-sizing: border-box;

    > :first-child {
      width: 22px;
      height: 22px;
      margin-right: 22px;
    }

    > :last-child {
      width: 24px;
      height: 24px;
    }
  }
}

.forget {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .forget-pass {
    font-size: 14px;
    color: #165dff;
    line-height: 22px;
  }
}

.check {
  margin: 20px 0 12px 50px;
}

.newcheck {
  margin-left: 0;
}

::v-deep .el-checkbox,
::v-deep .el-checkbox__label {
  font-size: 12px;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #86909c;
}

.go {
  width: 100%;
  text-align: center;
  margin: 32px 0;
  font-size: 14px;
  color: #a9aeb8;
  line-height: 1.5;
}

.el-radio {
  margin: 20px 50px 12px 0;
}

a {
  text-decoration: none;
}

.email {
  font-size: 14px;
  color: #4e5969;
  line-height: 1.5;
  margin-bottom: 6px;
  margin-top: 20px;
}

.regis {
  justify-content: space-between;
}

.register {
  display: flex;
  justify-content: space-between;
  line-height: 1.5;
  align-items: center;
  color: #1d2129;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 8px;
}

.point {
  cursor: pointer;
}

::v-deep .el-dialog--center .el-dialog__body,
::v-deep .el-dialog__header {
  padding: 0;
}

// ::v-deep .el-button {
//     width: 100% !important;
//     // border: none !important;
// }
::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: #86909c !important;
}

::v-deep .el-form-item {
  margin-bottom: 12px !important;
}

::v-deep .el-radio__inner {
  width: 16px !important;
  height: 16px !important;
  border-radius: 2px 2px 2px 2px !important;
  border: 1px solid #e5e6eb !important;
}

::v-deep .el-input__inner {
  background: #f7f8fa !important;
  border: none !important;
  border-radius: 4px 4px 4px 4px !important;
}

// ::v-deep .el-tabs__header {
//     margin-bottom: 32px !important;
// }
::v-deep .el-tabs__active-bar {
  background-color: #165dff !important;
  height: 3px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
}

::v-deep .el-tabs__item.is-active {
  color: #165dff !important;
}

::v-deep .el-tabs__item {
  color: #4e5969 !important;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  color: #165dff !important;
  border: none !important;
  margin: 0 15px !important;
}

::v-deep .el-input-group__append {
  padding-right: 15px !important;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none !important;
}

::v-deep .el-radio__label {
  font-size: 12px !important;
}

::v-deep .el-dialog {
  width: 376px !important;
  // margin: 0 auto !important;
  padding: 32px 48px !important;
  background: #ffffff !important;
  border-radius: 12px !important;
}

.content {
  width: 100% !important;
  font-size: 14px !important;
  position: relative;
}

.login {
  width: 376px !important;
  margin: 0 auto !important;
  padding: 32px 48px !important;
  background: #ffffff !important;
  border-radius: 12px !important;
}

.backg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100vh;
  background: rgba(29, 33, 41, 0.6000000238418579);
}
</style>
